/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Submission } from './Submission';
import {
    SubmissionFromJSON,
    SubmissionFromJSONTyped,
    SubmissionToJSON,
} from './Submission';

/**
 * 
 * @export
 * @interface PaginatedSubmissionList
 */
export interface PaginatedSubmissionList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedSubmissionList
     */
    count?: number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedSubmissionList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedSubmissionList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<Submission>}
     * @memberof PaginatedSubmissionList
     */
    results?: Array<Submission>;
}

/**
 * Check if a given object implements the PaginatedSubmissionList interface.
 */
export function instanceOfPaginatedSubmissionList(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PaginatedSubmissionListFromJSON(json: any): PaginatedSubmissionList {
    return PaginatedSubmissionListFromJSONTyped(json, false);
}

export function PaginatedSubmissionListFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedSubmissionList {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': !exists(json, 'count') ? undefined : json['count'],
        'next': !exists(json, 'next') ? undefined : json['next'],
        'previous': !exists(json, 'previous') ? undefined : json['previous'],
        'results': !exists(json, 'results') ? undefined : ((json['results'] as Array<any>).map(SubmissionFromJSON)),
    };
}

export function PaginatedSubmissionListToJSON(value?: PaginatedSubmissionList | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
        'next': value.next,
        'previous': value.previous,
        'results': value.results === undefined ? undefined : ((value.results as Array<any>).map(SubmissionToJSON)),
    };
}

